import { Box, Button, Grid, styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { GridSkeleton, SkeletonTable, SkeletonText } from "../ProfileTabPage";
import KontakReferensiModal from "./Components/KontakReferensiModal";
import KontakReferensiTable from "./Components/KontakReferensiTable";
import { LoadingOverlay } from "../../../components/LoadingOverlay";
import useFetchAllKontakReferensi from "./../../../api/effects/queries/KontakReferensi/useFetchAllKontakReferensi";


const TitleGrid = styled(Grid)(({ theme }) => ({
    paddingLeft: "5%",
    paddingBottom: "1%",
    paddingTop: "1%",
}));

const ButtonGrid = styled(Grid)(({ theme }) => ({
    paddingRight: "5%",
    paddingBottom: "1%",
    paddingTop: "1%",
}));

export default function KontakReferensiPage() {
    const [modalStateKontakReferensi, setModalStateKontakReferensi] = useState(false);
    const [kontakDarurat, setKontakDarurat] = useState("");
    const [loading, setLoading] = useState(true);

    const handleCloseModalKontakReferensi = () => {
        setModalStateKontakReferensi(false);
    };

    const handleOpenModalKontakReferensi = () => {
        setModalStateKontakReferensi(true);
    };

    // useEffect(() => {
    //     setLoading(false);
    // }, []);

    // if (loading) {
    //     return (
    //         <GridSkeleton justifyContent="center" alignItems="center">
    //             <SkeletonText variant="text" />
    //             <SkeletonTable variant="rectangular" />
    //         </GridSkeleton>
    //     );
    // }

    const { data: kontakDaruratData, isLoading: isKontakReferensiLoading } = useFetchAllKontakReferensi();
    const pageIsLoading = isKontakReferensiLoading;


    return (
        <Box>
            <KontakReferensiModal
                ID={-1}
                open={modalStateKontakReferensi}
                handleClose={handleCloseModalKontakReferensi}
            />
            <LoadingOverlay isLoading={pageIsLoading}>
                <TitleGrid container item xs={12} justifyContent="flex-start">
                    <Typography variant="h5">
                        Kontak Referensi
                    </Typography>
                </TitleGrid>
                <KontakReferensiTable />
                <ButtonGrid container item xs={12} justifyContent="flex-end">
                    <Button variant="contained" onClick={handleOpenModalKontakReferensi}>
                        Tambah Kontak Referensi
                    </Button>
                </ButtonGrid>
            </LoadingOverlay>
        </Box>
    );
}